import { Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import TempFileUploader from '../../../../components/Files/TempFileUploader';
import JoditEditor from 'jodit-react';
import ReactHtmlParser from 'react-html-parser';
import jodit from '../../../../utils/jodit';

const EditReference = ({ title = null, item = null, onClose = () => null, onApply = () => null }) => {
	const { t } = useTranslation();
	const [description, setDescription] = useState(item?.description || '');
	const [uploadingFile, setUploadingFile] = useState(false);
	const [isValid, setValid] = useState(false);
	const [file, setFile] = useState(null);

	useEffect(() => setValid(ReactHtmlParser(description)?.length !== 0), [description]);

	useEffect(() => {
		if (item) {
			setDescription(item?.description || '');
			setFile(item?.file || null);
		}
	}, [item]);

	const config = useMemo(
		() => ({
			minHeight: 24,
			showPlaceholder: false,
			toolbarSticky: false,
			toolbarAdaptive: false,
			toolbarInlineForSelection: false,
			inline: false,
			readonly: false,
			toolbar: true,
			statusbar: false,
			buttons: jodit?.minimalButtons,
			controls: jodit?.controls,
		}),
		[]
	);

	function applying() {
		if (description) {
			const updatedReference = { ...item, id: item?.id || uuidv4(), description, file };
			onApply(updatedReference);
			onClose();
		}
	}

	return (
		<Modal size="4xl" isOpen={true} onClose={() => onClose(false)}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{t(title)}</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<JoditEditor value={description} config={config} tabIndex={1} onChange={(e) => setDescription(e)} />
					<Flex pt={4} pb={4}>
						<TempFileUploader
							callBack={setFile}
							label={t('Attachment')}
							required={false}
							onCancelFile={() => setUploadingFile(false)}
							callBackUploading={(e) => setUploadingFile(e)}
							disabled={uploadingFile}
							mt={0}
							mb={0}
							size="sm"
							initialFile={file}
						/>
					</Flex>
				</ModalBody>
				<ModalFooter>
					<Button isDisabled={uploadingFile || !isValid} onClick={applying} colorScheme="blue" float="right" mb={2}>
						{t('Submit')}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default EditReference;
